import type { ReactNode } from 'react';
import { Alert, Skeleton } from '@argink/ui';

/**
 * Wrapper reutilizável de loading/empty/error/success (IMVP-01 — "toda rota e todo
 * bloco assíncrono relevante têm loading, empty, error e success definidos").
 * Nunca decide o texto por conta própria: cada consumidor passa a copy certa.
 */
export function LoadingBlock({ label = 'Carregando' }: { label?: string }) {
  return (
    <div className="state-block state-block--loading">
      <Skeleton lines={4} label={label} />
    </div>
  );
}

export function EmptyBlock({
  title,
  description,
  action,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="state-block state-block--empty">
      <p className="state-block__title">{title}</p>
      {description ? <p className="state-block__description">{description}</p> : null}
      {action}
    </div>
  );
}

export function ErrorBlock({
  title,
  description,
  action,
}: {
  title: string;
  description?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Alert tone="danger" title={title}>
      {description}
      {action ? <div className="state-block__actions">{action}</div> : null}
    </Alert>
  );
}
